const CheckoutStage = require('@/lib/Checkout/CheckoutStage');
const { clearLoadingMessage, setLoadingMessage } = require('@/functions/ui');

class OrderConfirmer {
    /**
     * @param {EInvoicingService} eInvoicingService
     * @param {OrdersApi} ordersApi
     */
    constructor(
        eInvoicingService,
        ordersApi
    ) {
        this.eInvoicingService = eInvoicingService;
        this.ordersApi = ordersApi;
    }

    /**
     * Just the API request to confirm the order, with the loading overlay shown while it runs.
     * Throws if the order could not be confirmed.
     * Callers should also call postConfirm once the order and anything else that belongs to it
     * (such as payments) has been saved.
     *
     * @param {number} orderID
     *
     * @returns {Promise<OrderResponse>}
     */
    async confirm(orderID) {
        setLoadingMessage('CHECKOUT_PROCESSING_MESSAGES.' + CheckoutStage.CONFIRM_ORDER);
        try {
            return await this.ordersApi.confirmOrder(orderID);
            // No catch - let it throw.
        } finally {
            clearLoadingMessage();
        }
    }

    /**
     * Perform the standard actions that need to happen after an order has been confirmed.
     *
     * @param {Order} order
     *
     * @returns {Promise}
     */
    async postConfirm(order) {
        await this.eInvoicingService.createInvoiceIfNeeded(order);
    }

    /**
     * Perform the standard actions that need to happen after an order adjustment has been confirmed.
     * Note that adjustments are auto confirmed by the API, so this is only called after the adjustment has
     * been confirmed and saved.
     *
     * @param {OrderAdjustmentResponse} orderAdjustmentResponse
     * @param {Order} order The adjusted order.
     *
     * @returns {Promise}
     */
    async postAdjustmentConfirm(orderAdjustmentResponse, order) {
        await this.eInvoicingService.createAdjustmentCreditNoteIfNeeded(orderAdjustmentResponse, order);
    }
}

module.exports = OrderConfirmer;
